import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	errorFlagTitleNonFinal: {
		defaultMessage: 'Something went wrong',
		id: 'personal-settings-error-flag.error-flag-title-non-final',
		description: 'Title for the error flag when updating the notification preferences fails.',
	},
	errorFlagDescriptionNonFinal: {
		defaultMessage:
			"There was an issue updating your notifications preference, we're working on fixing it, please try again later.",
		id: 'personal-settings-error-flag.error-flag-description-non-final',
		description: 'Error message description when updating the notification preferences fails.',
	},
});
